const getters = {
  getUser(state) {
    return state.user;
  },
  getUniversity(state) {
    return state.user ? state.user.university : false;
  },
  getCreditCards(state) {
    return state.user.credit_cards ? state.user.credit_cards : false;
  },
  getUserPhoto(state) {
    return state.userPhoto;
  },
  getIsAvailableToThirdOrder(state, getters) {
    return getters.getUser.is_admin || getters.getUser.is_runner;
  },
  getRappyPayMessage(state) {
    return state.rappyPayMessage;
  },
  getUniversityVariables(state) {
    return state.universityVariables;
  },
  getQuestions(state) {
    return state.questions;
  },
  getPseBanks(state) {
    return state.pseBanks;
  },
  getCurrentAddress(state) {
    return state.currentAddress;
  },
  getCurrentCityZone(state) {
    return state.currentCityZone;
  },
  getCurrentProgram(state) {
    return state.currentProgram;
  },
  getTraits(state) {
    return state.traits;
  },
  getCurrentPaymentMethod(state) {
    return state.currentPaymentMethod;
  },
  getPseInformation(state) {
    return state.pseInformation;
  },
  getBoughtProducts(state) {
    return state.boughtProducts;
  },
  getAcceptanceToken(state) {
    return state.acceptanceToken;
  },
  getRecentProducts(state) {
    if (state.recentProducts && state.recentProducts.length) {
      return state.recentProducts.filter((product) => product.is_deleted === false);
    }
  },
  getIsOnDemandValid(state) {
    return state.isOnDemandValid;
  },
};

export default getters;
